var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-layout"},[_c('AuthBackground'),_c('div',{staticClass:"auth-layout__form"},[_c('div',{class:[
        'auth-layout__slot',
        { 'auth-layout__slot-full-height': _vm.isFullHeight }
      ]},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }